import { useEffect } from 'react';
import { useAuth } from 'context/auth';
import {
  clearRedirectOptions,
  getRedirectOptions,
} from 'utils/redirectOptions';

type Props = {
  actions: {
    name: string;
    action: () => void;
  }[];
};

export const useRedirectActions = ({ actions }: Props) => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      return;
    }

    const redirectOptions = getRedirectOptions();

    actions.forEach((item) => {
      if (redirectOptions?.action === item.name) {
        clearRedirectOptions();
        if (item.action) {
          item?.action();
        }
      }
    });
  }, [actions, isLoggedIn]);
};
